import { CanvasCard as CanvasCardComponent } from "@circle-react-shared/CanvasCard";
import type { CanvasProps } from "@circle-react-shared/CanvasCard";

export const CanvasCard = (props: CanvasProps) => (
  <CanvasCardComponent data-testid="builder-ui-canvas-card" {...props} />
);
